import { useCallback } from 'react';
import cl from 'classnames';

import {
  CategoryID,
  CategoryLocalizedName
} from '../../../../../../../../categories/categoriesTypes';

import { Checkbox } from '../../../../../../../../../helpers/Checkbox';
import { PureButtonHelper } from '../../../../../../../../../helpers/buttons/PureButtonHelper';

interface ThreeDStockProductsFiltersCategoriesFilterItemCategory {
  id: CategoryID;
  localizedName: CategoryLocalizedName;
}

interface ThreeDStockProductsFiltersCategoriesFilterItemProps {
  category: ThreeDStockProductsFiltersCategoriesFilterItemCategory;
  onCheckedCategory: (categoryId: CategoryID) => void;
  onChangeCategory: (categoryId: CategoryID) => void;
  checked: boolean;
  isCompact?: boolean;
  withoutCategoryDrilldown?: boolean;
}

function ThreeDStockProductsFiltersCategoriesFilterItem({
  onCheckedCategory,
  onChangeCategory,
  category,
  checked,
  isCompact,
  withoutCategoryDrilldown
}: ThreeDStockProductsFiltersCategoriesFilterItemProps) {
  const handleCheck = useCallback(() => {
    onCheckedCategory(category.id);
  }, [onCheckedCategory, category]);

  const handleChange = useCallback(() => {
    onChangeCategory(category.id);
  }, [onChangeCategory, category]);

  // Without drilldown the whole row is just a checkbox — clicking the name
  // toggles it, same as ThreeDStockProductsFiltersBrandsFilterItem.
  if (withoutCategoryDrilldown) {
    return (
      <li className={isCompact ? 'py-0.5' : 'py-1'}>
        <Checkbox
          dataGa={`category-${category.localizedName}`}
          checkboxWrapperClassName="flex items-center"
          checkboxClassName={
            isCompact ? 'basic-checkbox h-3.5 w-3.5' : undefined
          }
          labelClassName={cl(
            'ml-2 block text-gray-900 dark:text-gray-100 cursor-pointer',
            isCompact ? 'text-xs' : 'text-sm'
          )}
          i18nLabel={category.localizedName}
          checked={checked}
          onChange={handleCheck}
        />
      </li>
    );
  }

  return (
    <li>
      <div className={cl('flex items-center', isCompact ? 'py-0.5' : 'py-1')}>
        <Checkbox
          dataGa={`category-${category.localizedName}`}
          checked={checked}
          onChange={handleCheck}
          checkboxClassName={
            isCompact ? 'basic-checkbox h-3.5 w-3.5' : undefined
          }
        />

        <PureButtonHelper
          className={cl(
            'grow text-left ml-2 block text-gray-900 dark:text-gray-100 hover:underline hover:font-medium',
            isCompact ? 'text-xs' : 'text-sm'
          )}
          i18nText={category.localizedName}
          onClick={handleChange}
        />
      </div>
    </li>
  );
}

export default ThreeDStockProductsFiltersCategoriesFilterItem;
